(function() {
'use strict'

AppTabs.createTab( {
	name: 'attachment',
	icon: 'paperclip',
	text: 'Attachment',
	create: function(init) {
		const tab = this;
		const anchor = document.getElementById('download-attachment-anchor');
		const span = document.getElementById('attachment-filename');
		let attachmentObject = null;
		let objectURL = null;
		function reset() {
			anchor.download = '';
			anchor.href = '';
			span.innerText = '';
			if (attachmentObject != null)
				tab.container.removeChild(attachmentObject);

			if (objectURL != null)
				URL.revokeObjectURL(objectURL);
		}

		init.setController( {
			OpenAttachment(jobNumber, filename) {
				reset();
				const request = new XMLHttpRequest();
				request.open('POST', ajax_object.ajax_url, true);
				request.responseType = 'blob';
				request.onload = function() {
					objectURL = URL.createObjectURL(request.response);
					attachmentObject = document.createElement('object')
					attachmentObject.setAttribute('style', 'margin:0;padding:0;width:100%;height:100%;border:none;');
					attachmentObject.setAttribute('type', request.getResponseHeader("Content-Type"));
					attachmentObject.setAttribute('data', objectURL);
					tab.container.appendChild(attachmentObject);

					// "Content-Disposition:inline;filename=\"filename\""
					const contentDisposition = request.getResponseHeader("Content-Disposition");
					if (contentDisposition) {
						let parts = contentDisposition.split('=');
						if (parts.length > 1 && parts[1])
							anchor.download = decodeURIComponent(parts[1].substring(1, parts[1].length - 1).replace(/\+/g, '%20'));

						if (!anchor.download)
							anchor.download = filename;
					}

					anchor.href = objectURL;
					span.innerText = anchor.download;
				};
				request.onerror = function() {
					attachmentObject = document.createElement('div');
					attachmentObject.setAttribute('style', 'margin:3em;width:auto;height:auto;text-align:center;');
					attachmentObject.innerText = request.statusText;
					tab.container.appendChild(attachmentObject);
				};
				request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
				request.send(JSON.stringify( {
					session_id: ajax_object.session_id,
					action: 'get_job_attachment',
					jobNumber: jobNumber,
					filename: filename,
				} ));
				tab.show();
			},
			onTabClose() {
				reset();
			},
		} );
	}
});

})();